import _ from 'lodash'
import { isMobile } from 'mobile-device-detect'
import { fotmatPercent, progressRound } from '@/helpers/format'
import { midnightTomorrowFromToday, addDays, formatyyymmdd } from '@/helpers/date'

export default {
  // global
  appLoading: (state) => state.appLoading,
  isMobile: () => { return isMobile },
  isSmallScreen: (state, getters) => {
    return getters.isMobile || getters.windowWidth <= 1024
  },
  isLargeScreen: (state, getters) => {
    return !getters.isSmallScreen
  },
  handleClass: () => { return isMobile ? '' : 'handle' },
  onboardingTourFinished: (state) => state.onboardingTourFinished,
  soundEffect: (state) => state.soundEffect,
  today: (state) => state.today,
  todayKey: (state) => formatyyymmdd(state.today),
  tasksListFilter: (state) => state.tasksListFilter,
  routinesListFilter: (state) => state.routinesListFilter,
  goalsListFilter: (state) => state.goalsListFilter,
  tomorrow: (state) => midnightTomorrowFromToday(state.today),
  dayAfterTomorrow: (state, getters) => addDays(getters.tomorrow, 1),
  dayAfterTomorrow1: (state, getters) => addDays(getters.tomorrow, 2),
  dayAfterTomorrow2: (state, getters) => addDays(getters.tomorrow, 3),
  dayAfterTomorrow3: (state, getters) => addDays(getters.tomorrow, 4),
  dayAfterTomorrow4: (state, getters) => addDays(getters.tomorrow, 5),
  dayAfterTomorrow5: (state, getters) => addDays(getters.tomorrow, 6),
  dayAfterTomorrowWeekDay: (state, getters) => {
    return _.lowerCase(
      getters.dayAfterTomorrow.toLocaleDateString('en-GB', { weekday: 'long' })
    )
  },
  // nav
  navGoals: (state, getters) => {
    if (state.appLoading) return {}

    if (_.size(getters.currentGoalsNotDropped) === 0) return {}

    const percentMean = progressRound(_.meanBy(getters.currentGoalsNotDropped, 'progressPercent'))

    if  (percentMean === 100) {
      return { tag: '✓', tagColor: 'success' }
    } else if (percentMean > 75) {
      return { tag: fotmatPercent(percentMean), tagColor: 'success' }
    } else {
      return { tag: fotmatPercent(percentMean), tagColor: 'primary' }
    }
  },
  navDreams: (state, getters) => {
    if (state.appLoading) return {}

    const tag = !_.size(getters.dreams) ? '!' : null
    const tagColor = 'danger'

    return { tag, tagColor }
  },
  navPlanner: (state, getters) => {
    if (state.appLoading) return {}

    const tag = _.size(getters.dreams) && !_.size(getters.goals) ? '!' : null
    const tagColor = 'danger'

    return { tag, tagColor }
  },
  navJourney: () => {
    return {}
  },
  showSetup: (state) => state.showSetup,
  navStories: () => {
    return {}
    // if (state.appLoading) return {}

    // const implementedAt = new Date(2020, 7, 17)
    // const tag = (getters.user.registeredAt < implementedAt && _.size(getters.stories) === 0) ?
    //   'New' : null
    // const tagColor = 'success'

    // return { tag, tagColor }
  },
  navInsights: () => {
    return {}
    // if (state.appLoading) return {}

    // const implementedAt = new Date(2020, 7, 28)
    // const tag = (getters.user.registeredAt < implementedAt) ? 'New' : null // TODO:
    // const tagColor = 'success'

    // return { tag, tagColor }
  },
  navLessons: (state, getters) => {
    if (state.appLoading) return {}

    const count = getters.openLessonsCount
    return count > 0 ? { tag: count, tagColor: 'dark' } : {}
  },
  navTips: (state, getters) => {
    if (state.appLoading) return {}

    const count = getters.unreadTipsCount
    return count > 0 ? { tag: count, tagColor: 'danger' } : {}
  },
  allDataLoaded: (state, getters) => {
    return getters.tasksDataLoaded && getters.routineDataLoaded
  }
}
